module.exports = __webpack_public_path__ + "img/ic-heart-regular.652169b6.svg";